import { render, staticRenderFns } from "./ManualCheck.vue?vue&type=template&id=12deddd9&scoped=true"
import script from "./ManualCheck.vue?vue&type=script&lang=ts"
export * from "./ManualCheck.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./ManualCheck.vue?vue&type=style&index=0&id=12deddd9&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)
var style1 = require("./ManualCheck.vue?vue&type=style&index=1&id=12deddd9&prod&lang=scss")
if (style1.__inject__) style1.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "12deddd9",
  null
  ,true
)

export default component.exports